/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cad_Field_New_Contact_NameInputs */

const en_cad_field_new_contact_name = /** @type {(inputs: Cad_Field_New_Contact_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`New primary contact (optional)`)
};

const ja_cad_field_new_contact_name = /** @type {(inputs: Cad_Field_New_Contact_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`新しい主担当者（任意）`)
};

const fr_cad_field_new_contact_name = /** @type {(inputs: Cad_Field_New_Contact_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nouveau contact principal (optionnel)`)
};

const de_cad_field_new_contact_name = /** @type {(inputs: Cad_Field_New_Contact_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Neuer Hauptansprechpartner (optional)`)
};

/**
* | output |
* | --- |
* | "New primary contact (optional)" |
*
* @param {Cad_Field_New_Contact_NameInputs} inputs
* @param {{ locale?: "en" | "ja" | "fr" | "de" }} options
* @returns {LocalizedString}
*/
export const cad_field_new_contact_name = /** @type {((inputs?: Cad_Field_New_Contact_NameInputs, options?: { locale?: "en" | "ja" | "fr" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cad_Field_New_Contact_NameInputs, { locale?: "en" | "ja" | "fr" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_cad_field_new_contact_name(inputs)
	if (locale === "ja") return ja_cad_field_new_contact_name(inputs)
	if (locale === "fr") return fr_cad_field_new_contact_name(inputs)
	return de_cad_field_new_contact_name(inputs)
});